import { render, staticRenderFns } from "./DHCPServerModal.vue?vue&type=template&id=22126eaa&scoped=true&"
import script from "./DHCPServerModal.vue?vue&type=script&lang=ts&"
export * from "./DHCPServerModal.vue?vue&type=script&lang=ts&"
import style0 from "./DHCPServerModal.vue?vue&type=style&index=0&id=22126eaa&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22126eaa",
  null
  
)

export default component.exports